// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"errorBlock_colorPrimary__Mbq69","colorSecondary":"errorBlock_colorSecondary__lywDb","container":"errorBlock_container__M-M7x"};
    if(module.hot) {
      // 1746134851729
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  